module.exports = __webpack_public_path__ + "static/1 (4)-3daafb1e293589081c1caa4f26d3c704.jpg";